// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_ozC","cls2":"RecommendationsCard-cls2_GRk RecommendationsCard-cls1_ozC","altLook":"RecommendationsCard-altLook_Zj6"};